module.exports = __webpack_public_path__ + "img/kiosk.eeedacb3.png";